import { schema } from 'normalizr';

export const purchasedComponentSchema = new schema.Entity(
  'purchasedComponents',
);

export const customColumnSchema = new schema.Entity(
  'customPurchasedComponentColumns',
);
